import type { ParentComponent } from 'solid-js'
import { useService } from 'solid-services'
import { useSingle } from '../state'
import ArchivedAlert from './ArchivedAlert'
import Header from './Header'
import Hero from './Hero'
import Images from './Images'

const Single: ParentComponent = () => {
	const { setupResource } = useService(useSingle)()

	return (
		<>
			<ArchivedAlert />
			<Header setup={setupResource()!} />
			<Hero setup={setupResource()!} />
			{/* <Scoring /> */}
			<Images setup={setupResource()!} />
			{/* <Attributes setup={setupResource()!} /> */}
		</>
	)
}

export default Single
